import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer-container text-white p-4 text-center w-100">
      <Container>
        <Row>
          <Col>
            {/* Primer texto del footer */}
            <p>
              <strong>
                <a href="https://bellcapitalmx.com/aviso-de-privacidad/" target="_blank">
                  AVISO DE PRIVACIDAD
                </a>
              </strong>{' '}
              / TÉRMINOS Y CONDICIONES
              <br />
              COPYRIGHT &copy; {new Date().getFullYear()} BELL CAPITAL MX TODOS LOS DERECHOS
              RESERVADOS
            </p>
            <hr />
            {/* Segundo texto del footer */}
            <p>
              BELL CAPITAL MX y su logo son marcas registradas de CONSULTORES DIGITALES S.A.DE C.V.
              <br />
              Registro Federal de Contribuyentes: CDP240522848
              <br />
              Copyright&copy; {new Date().getFullYear()} Bell Capital MX Todos los derechos
              reservados
              <br />
              Desarrollado por BELL CAPITAL MX
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
